<template>
  <div class="price-promise-block">
    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon41.png" />
        <span>定价规则</span>
      </div>

      <div class="info">
        <table cellspacing="0" class="orange">
          <tbody>
            <tr>
              <td>服务项目</td>
              <td>基准定价</td>
            </tr>
            <tr>
              <td class="green">
                <p>专业课全面辅导（30-50小时）</p>
              </td>
              <td class="green">
                <p>
                  <del>6000元</del>
                  5400元
                </p>
              </td>
            </tr>
            <tr>
              <td class="green">
                <p>专业课重点辅导（10-20小时）</p>
              </td>
              <td class="green">
                <p>
                  <del>2800元</del>
                  2520元
                </p>
              </td>
            </tr>
            <tr>
              <td class="green">
                <p>专业课突击辅导（4-8小时）</p>
              </td>
              <td class="green">
                <p>
                  <del>2200元</del>
                  1980元
                </p>
              </td>
            </tr>
            <tr>
              <td class="blue">
                <p>复试笔试+面试辅导（2-4小时）</p>
              </td>
              <td class="blue">
                <p>
                  <del>1600（单选），1200（选择专业课辅导）</del>
                  1440（单选），1080（选择专业课辅导）
                </p>
              </td>
            </tr>
            <tr>
              <td class="red">
                <p>个性化指导选择导师（2-4小时）</p>
              </td>
              <td class="red">
                <p>
                  <del>1600（单选），1200（选择专业课辅导）</del>
                  1440（单选），1080（选择专业课辅导）
                </p>
              </td>
            </tr>
            <tr>
              <td class="red">
                <p>个性化指导选择/调剂院校（2-4小时）</p>
              </td>
              <td class="red">
                <p>
                  <del>1600（单选），1200（选择专业课辅导）</del>
                  1440（单选），1080（选择专业课辅导）
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>
                  *推广阶段，全部项目享受九折优惠，平台承诺试听不满意全额退款。试听后，根据双方细化的辅导方案和具体需求，在基准定价基础上调整最终服务报价。
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <p>为给受疫情影响的广大学子提供互助平台，圈内人承诺2021助考全流程对接过程不收取任何费用！上述报价为标准化辅导的指导性定价，辅导讲师的具体报价将由圈内人作为协商第三方，根据最终确定的服务内容和时长，协调双方意愿确定。请放心提交需求，若您对讲师的辅导报价不满意，可随时终止该服务。</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
/**
 * @description 考研辅导 - 定价与承诺
 */
// import * as api from '@/api/login'

export default {
  name: 'PricePromise',
  data() {
    return {
      ruleForm: {
        num: '', // 正文字数
        service_level: '', // 润色级别
        service_list: '', // 可选服务
        price: '', // 这是计算出来的最终价格展示
      },
      rules: {
        num: [
          { required: true, message: '请输入论文正文字数', trigger: 'blur' },
        ],
        service_level: [
          { required: true, message: '请选择润色级别', trigger: 'change' },
        ],
      },
    }
  },
  created() {},
  methods: {
    /**
     * @description 论文价格计算
     */
    submitForm(formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let _allPrice = 0 // 最终价格

          // 润色级别定价，根据字数定价
          let _wordPrice = 0 // 文字价格。这里的文字价格就指  原定价格
          if (_this.ruleForm.service_level == '基础版（590元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.59
          } else if (_this.ruleForm.service_level == '标准版（690元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.69
          } else if (_this.ruleForm.service_level == '高级版（890元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.89
          }
          // else if (_this.ruleForm.service_level == '定制版（线下协商）') {
          //   console.log( '定制版（线下协商）');
          // } else if (_this.ruleForm.service_level == '二三轮优惠或免费返修') {
          //   console.log( '二三轮优惠或免费返修');
          // }

          // 可选服务定价-根据所选服务的数量与质量
          // 可选服务的总价 = _servicePrice(其他服务) + _urgentPrice(加急时间) + _repairPrice(论文返修)
          let _servicePrice = 0

          // 加急时间的价格，1、2、3、4天，以最高加急天数的价格为准，多选覆盖
          let _urgentPrice = 0

          // 返修服务的价格，2、3、4轮返修，以最高轮次的返修的价格为准，多选覆盖
          let _repairPrice = 0

          // 论文翻译：原定价基础上增加100%，润色周期默认为12天。
          if (_this.ruleForm.service_list.indexOf('中文翻译') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 1
          }

          // 时间加急：默认润色周期为7个自然日，每加急一天在原定价基础上增加15%，最短润色周期为3天。
          if (_this.ruleForm.service_list.indexOf('加急1天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 1
          }
          if (_this.ruleForm.service_list.indexOf('加急2天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 2
          }
          if (_this.ruleForm.service_list.indexOf('加急3天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 3
          }
          if (_this.ruleForm.service_list.indexOf('加急4天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 4
          }

          // 3. 语音指导：润色专家提供长10-15分钟的论文点评/写作指导的录音，在原定价基础上增加20%。
          if (_this.ruleForm.service_list.indexOf('语音指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.2
          }

          // 4. 视频“面对面”指导：润色专家与作者（可多人）进行40-60分钟视频，进行论文修改、点评与写作指导。在原定价基础上增加50%。
          if (_this.ruleForm.service_list.indexOf('视频指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.5
          }

          // 5. 论文发表指导：润色专家针对论文内容、投稿期刊、答复审稿人方式等方面提供建议，直到论文发表。在原定价基础上增加50%。
          if (_this.ruleForm.service_list.indexOf('论文发表指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.5
          }

          // 6.返修服务：前1轮返修内容在10%文字量以内的部分免费润色；1-3轮返修不限字数重新润色分别需额外增加60%，40%，20%的价格。可在初次提交时勾选可选服务，也可在返修后补交差额购买返修服务。
          if (_this.ruleForm.service_list.indexOf('1轮返修不限字数润色') > -1) {
            _repairPrice = _wordPrice * 0.6
          }
          if (_this.ruleForm.service_list.indexOf('2轮返修不限字数润色') > -1) {
            _repairPrice = _wordPrice * 0.6 + _wordPrice * 0.4
          }
          if (_this.ruleForm.service_list.indexOf('3轮返修不限字数润色') > -1) {
            _repairPrice =
              _wordPrice * 0.6 + _wordPrice * 0.4 + _wordPrice * 0.2
          }

          // 可选服务的总价 = _servicePrice(其他服务) + _urgentPrice(加急时间) + _repairPrice(论文返修)
          _servicePrice = _servicePrice + _urgentPrice + _repairPrice

          // 总价 = 论文字数价格 + 可选服务总价  计算得出的总价保留整数向上补齐
          _allPrice = Math.ceil(_wordPrice + _servicePrice)
          // 最终的价格需要保留整数，最后的个位数字如果不是0的话，需要进一位，十位+1，个位变0
          // 例如 1009 =》 1010    991.78 =》 1000
          _this.ruleForm.price = Math.ceil(_allPrice / 10) * 10
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    /**
     * @description 论文价格计算的form初始化
     */
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    /**
     * @description 联系我们
     */
    toContact() {
      this.$router.push({
        path: '/about',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.price-promise-block {
  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    .info {
      padding: 0 20px;

      .el-form {
        margin: 20px 0 0 0;

        .el-select {
          width: 100%;
        }
      }

      p {
        color: #98a5a6;
        line-height: 1.6;
        margin: 0;
      }

      .payment {
        display: block;
        margin: 10px 0;
        width: 100%;
      }

      .alipay {
        display: block;
        margin: 10px 0;
        width: 200px;
      }

      table {
        width: 100%;
        margin: 20px 0;
        border: 1px solid #e39f24;
        color: #e39f24;

        td {
          border: 1px solid #e39f24;
          color: #e39f24;
          padding: 10px;
          text-align: center;

          p {
            color: #e39f24;
          }
        }

        .blue {
          color: #3d9aba;
          border-color: #3d9aba;

          p {
            color: #3d9aba;
          }

        }

        .red {
          color: #ed6e19;
            border-color: #ed6e19;
          p {
            color: #ed6e19;
          }
        }

        .green {
          color: #49ad87;
            border-color: #49ad87;
          p {
            color: #49ad87;
          }
        }
      }

      .align-left {
        text-align: left;
      }

      .background {
        width: 20px;
        padding: 10px 20px;
        background: #e39f24;
        color: #ffffff;
        font-size: 18px;
      }
    }

    //   .blue {
    //     border-color: #3d9aba;
    //     table,
    //     td {
    //       color: #3d9aba;
    //       border-color: #3d9aba;
    //     }
    //     p {
    //       color: #3d9aba;
    //     }
    //     .background {
    //       background: #3d9aba;
    //       color: #ffffff;
    //     }
    //   }

    //   .red {
    //     border-color: #ed6e19;
    //     table,
    //     td {
    //       color: #ed6e19;
    //       border-color: #ed6e19;
    //     }
    //     p {
    //       color: #ed6e19;
    //     }
    //     .background {
    //       background: #ed6e19;
    //       color: #ffffff;
    //     }
    //   }

    //   .green {
    //     border-color: #49ad87;
    //     table,
    //     td {
    //       color: #49ad87;
    //       border-color: #49ad87;
    //     }
    //     p {
    //       color: #49ad87;
    //     }
    //     .background {
    //       background: #49ad87;
    //       color: #ffffff;
    //     }
    //   }
    // }

    .text-indent p {
      text-indent: 32px;
    }
  }

  /deep/.el-alert {
    .el-alert__content {
      width: 100%;
    }
    .flex {
      display: flex;
      justify-content: space-between;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 250px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -25px;
    }
  }
}
</style>